<template>
  <button type="button" class="btn btn-outline-light m-0 p-0 btn-block !text-dark-100">
    <slot></slot>
  </button>
</template>
